export default __webpack_public_path__ + "static/media/Fav.c0bfb603.png";